// Live surcharge references. Populated at runtime from /api/v2/services —
// use-services-api.js Object.assigns the real records ({id, name, customerPrice,
// ... }) onto these once the API responds. Empty until then.
//
// There are NO baked prices here: the DB is the single source of truth and
// PriceText skeletons bridge the brief initial fetch. (Previously this file was
// a ~420-line baked `apiServices` array whose prices were never displayed and
// had drifted stale — e.g. Mini Valet £49 — so it was misleading dead data.)
export const LARGE_CAR_SERVICE = {}
export const SAME_DAY_SERVICE = {}
export const CONGESTION_ZONE_SERVICE = {}
